import { inject } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';

import { GqlService, OrganizationType } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';
import { Utils } from '@shared/utils/utils';

const vendorKeys = {
  index: ['vendor'] as const,
  listAmountTypes: (trialKey: string) => [...vendorKeys.lists(trialKey), 'amount-types'] as const,
  lists: (trialKey: string) => [...vendorKeys.index, 'list-vendors', { trialKey }] as const,
};

export const injectListVendors = (includeInactive = false) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    queryFn: async () => {
      const data = await gqlToPromise(() => gqlService.listOrganizations$(includeInactive));

      return (data || [])
        .filter((entity) => entity.organization_type === OrganizationType.ORGANIZATION_VENDOR)
        .sort((a, b) => Utils.localeAlphaNumSort(a.name, b.name));
    },
    queryKey: vendorKeys.lists(mainQuery.trialKey()),
  }));
};

export const injectVendorsAmountTypes = () => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    queryFn: () => {
      return gqlToPromise(() => gqlService.listVendorAmountTypes$());
    },
    queryKey: vendorKeys.listAmountTypes(mainQuery.trialKey()),
  }));
};
